import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface CookieContextState {
  isCookiePopupOpen?: boolean;
  cookieSelection?: string;
}

const initialState: CookieContextState = {
  isCookiePopupOpen: false,
  cookieSelection: '',
};

const cookieContextSlice = createSlice({
  name: 'cookie-context',
  initialState,
  reducers: {
    setIsCookiePopupOpen: (state, action) => {
      state.isCookiePopupOpen = action.payload;
    },
    setCookieSelection: (state, action) => {
      state.cookieSelection = action.payload;
    },
  },
});

export const { setIsCookiePopupOpen, setCookieSelection } = cookieContextSlice.actions;
export const isCookiePopupOpenRedux = (state: RootState) => state.cookieContext.isCookiePopupOpen;
export const cookieSelectionRedux = (state: RootState) => state.cookieContext.cookieSelection;
export default cookieContextSlice.reducer;
